import { Media } from "react-bootstrap";
import { BASE_URL } from "../../helper/constants";
import { Skeleton } from "@material-ui/lab";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import React, { useEffect, useState } from "react";
import LanguageContext from "../../helper/LanguageContext";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link, useHistory } from "react-router-dom";
import { callAPI } from "../../helper/apiUtils";
import { requestDirectMessage } from "../../helper/directMessagePrompt";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as SmilyIcon } from "../../Icons/SmilyDeselected.svg";
import { useCurrentUserProfileData } from "../../helper/UserFactory";
import {
  convertBranchRole,
  convertHtmlString,
  tempFunction,
} from "../../helper/convertor";
import PlayerFeed from "../../components/PlayerFeed";
import ReadMores from "../../components/ReadMores";
import { isNativeVideoAttachment } from "../../utils/chatVideo";
import { RIGHT_TOP, SET_OPEN_SIDE_BAR, SET_VIEWER_IINITAL_INDEX, SET_VIEWER_IMAGES, SET_VIEWER_IS_INTERNAL } from "../../store";
import ReactTooltip from "react-tooltip";
import LikesDropdown from "../../components/LikesDropdown";
import MaterialIcon from "../../components/MaterialIcon";
import ArticleAdminMenu from "../../components/ArticleAdminMenu";
import { stripMarkdownFromTitle as toPlainArticleTitle } from "../../helper/stripMarkdownTitle";
import { HighlightText } from "../../helper/highlightSearch";
import "./CompanyFeed.css";
const extractUrls = require("extract-urls");

export function CompanyFeed({
  isInternal,
  article,
  index,
  expandArticle,
  reloadArticle,
  viewArticleDetail,
  handleLike,
  isDetails = false,
  canPinArticle = false,
  onTogglePin,
  isPinned = false,
  pinLoading = false,
  internalCompanyId = null,
  searchQuery = "",
  canManageArticle = false,
  onEditArticle,
  onDeleteArticle,
}) {
  const dispatch = useDispatch();
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [likeStatus, setLikeStatus] = useState(false);
  const [_Link, _setLink] = useState(null);
  const user = useSelector((state) => state.user);
  const history = useHistory();
  const [showLikesTooltip, setShowLikesTooltip] = useState(false);
  const [likeHover, setLikeHover] = useState(false);
  const descriptionRef = React.useRef(null);
  const IMAGE_STYLE_ID = "company-feed-image-limit-style";
  const pinButtonTitle = isPinned
    ? (strings.unpin_article)
    : (strings.pin_article);
  const handlePinClick = () => {
    if (pinLoading) {
      return;
    }
    if (onTogglePin) {
      onTogglePin();
    }
  };
  const likeArticle = async (article) => {
    setLikeStatus(true);
    if (user?.id !== article.postedById) {
      handleLike(article.id);
      try {
        await callAPI(
          `/article/${article.id}/like`,
          {
            id: article.id,
            emoji: 6,
            lang: "en",
          },
          "GET"
        );
      } catch (err) {
        handleLike(article.id);
      }
    }
    setTimeout(() => {
      setLikeStatus(false);
    }, 1000);
  };
  const getAuthorProfile = (postedById) => {
    if (!postedById) {
      return;
    }
    requestDirectMessage({
      id: postedById,
      fullName: article.postedByName || article.fullName || `${article.firstName || ""} ${article.lastName || ""}`.trim(),
      avatar: article.avatar || article.postedByAvatar || article.postedByImage,
    });
  };

  const getCompany = (createdById) => {
    dispatch({ type: RIGHT_TOP, rightTop: '' })
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: '' })
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const profile = useCurrentUserProfileData();
    const { companies } = profile;
    if (companies.length > 0) {
      const getId = companies.find((c) => c.id === createdById);
      if (getId) {
        history.push({
          pathname: "/cockpit",
          search: `?tab=company&company=${encodeURIComponent(getId.id)}`,
          state: article.id,
        });
      } else {
        history.push({
          pathname: `/foreign-company-details/${createdById}`,
          state: article.id,
        });
      }
    } else {
      history.push({
        pathname: `/foreign-company-details/${createdById}`,
        state: article.id,
      });
    }
  };

  const viewFullScreen = async () => {
    viewArticleDetail(article);
  };
  const [articleBranch, setArticleBranch] = React.useState([]);
  React.useEffect(() => {
    setArticleBranch(convertBranchRole(article.buildingIndustryRole, isGerm));
  }, [article]);

  const imageCount = React.useMemo(() => {
    if (!_Link || !Array.isArray(_Link)) {
      return 0;
    }
    return _Link.filter((item) => {
      if (item?.videoType) {
        return false;
      }
      const fileType = (item?.fileType || "").toLowerCase();
      if (fileType.includes("video")) {
        return false;
      }
      if (isNativeVideoAttachment(item)) {
        return false;
      }
      return true;
    }).length;
  }, [_Link]);

  const hasVideo = React.useMemo(() => {
    if (!_Link || !Array.isArray(_Link)) {
      return false;
    }
    return _Link.some((item) => !!(item?.videoType || isNativeVideoAttachment(item)));
  }, [_Link]);

  const shouldLimitMedia = imageCount === 1 && !hasVideo;

  useEffect(() => {
    if (!document.getElementById(IMAGE_STYLE_ID)) {
      const style = document.createElement("style");
      style.id = IMAGE_STYLE_ID;
      style.innerHTML = `
        .company-feed-image-scope img {
          max-width: 100%;
          width: 100%;
          height: auto;
          max-height: 270px;
          object-fit: contain;
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  useEffect(() => {
    if (article?.description && typeof article?.description === "string") {
      // let dec = article?.description.replace(/<[^>]*>/g, '')
      let datax = extractUrls(article?.description);
      datax =
        datax && Array.isArray(datax)
          ? datax?.map((e) => {
            return e.replace("&quot", "");
          })
          : datax;
      // const data = extractUrls(route.params.description.replace(/<[^>]*>/g, ''));
      let data = [...new Set(datax)];
      let all = [];
      if (data && data.length > 0) {
        for (let obj of data) {
          let x = {
            href: obj,
          };
          let lnk = obj;
          if (lnk.match("vimeo")) {
            x.videoType = "vimeo";
            all.push(x);
          }
          if (lnk.match("youtube") || lnk.match("youtu")) {
            x.videoType = "youtube";
            all.push(x);
          }
        }
        if (all.length > 0) {
          if (article.uploadUrl && article.uploadUrl.length > 0)
            _setLink([...all, ...article.uploadUrl]);
          else _setLink([...all]);
        } else if (article.uploadUrl && article.uploadUrl.length > 0) {
          _setLink([...article.uploadUrl]);
        }
      } else {
        if (article.uploadUrl && article.uploadUrl.length > 0) {
          _setLink([...article.uploadUrl]);
        }
      }
    } else if (article.uploadUrl && article.uploadUrl.length > 0) {
      _setLink([...article.uploadUrl]);
    }
  }, [article]);

  useEffect(() => {
    if (!shouldLimitMedia) {
      return;
    }
    if (descriptionRef.current) {
      const images = descriptionRef.current.querySelectorAll("img");
      images.forEach((img) => {
        img.style.maxWidth = "100%";
        img.style.width = "100%";
        img.style.height = "auto";
        img.style.maxHeight = "270px";
        img.style.objectFit = "contain";
        if (img.hasAttribute("width")) {
          img.removeAttribute("width");
        }
        if (img.hasAttribute("height")) {
          img.removeAttribute("height");
        }
      });
    }
  }, [article?.description, shouldLimitMedia]);


  const showPinButton = isInternal && canPinArticle;
  const showAdminActions = canManageArticle || showPinButton;

  return (
    <div className={`feed-details${showAdminActions ? ' has-admin-actions' : ''}${showPinButton ? ' has-pin' : ''}${canManageArticle ? ' has-manage-menu' : ''}`}>
      {showAdminActions && (
        <div className="article-admin-actions">
          {canManageArticle && onEditArticle && onDeleteArticle && (
            <ArticleAdminMenu
              onEdit={onEditArticle}
              onDelete={onDeleteArticle}
            />
          )}
          {showPinButton && (
            <button
              type="button"
              className={`kj-btn kj-btn--icon kj-btn--lg kj-btn--neutral kj-btn--internal article-pin-btn ${isPinned ? 'pinned' : ''} ${pinLoading ? 'loading' : ''}`}
              onClick={handlePinClick}
              disabled={pinLoading}
              aria-pressed={isPinned}
              aria-label={pinButtonTitle}
              title={pinButtonTitle}
            >
              <MaterialIcon
                icon="keep"
                size={24}
                weight={300}
                fill={isPinned ? 1 : 0}
              />
            </button>
          )}
        </div>
      )}
      <Media className="article-author-media">
        {console.log(BASE_URL + article.avatar)}
        {!isInternal ? (
          <img
            width={40}
            height={40}
            // className="mr-3 news_profile"
            src={
              article.logo
                ? BASE_URL + article.logo
                : article.avatar
                  ? BASE_URL + article.avatar
                  : article.postedByImage
                    ? BASE_URL + article.postedByImage
                    : process.env.PUBLIC_URL + "/assets/img/Companies-No-Image.svg"
            }
            alt="Generic placeholder"
            className="company-feed__author-img"
          />
        ) : (
          <img
            width={25}
            height={25}
            // className="mr-3 news_profile"
            src={
              article.postedByImage
                ? BASE_URL + article.postedByImage
                : article.userAvatar
                  ? BASE_URL + article.userAvatar
                  : article.userImage
                    ? BASE_URL + article.userImage
                    : article.userProfileImage
                      ? BASE_URL + article.userProfileImage
                      : process.env.PUBLIC_URL + "assets/img/head.svg"
            }
            alt="Generic placeholder"
            className="company-feed__author-img company-feed__author-img--round"
          />
        )}
        <Media.Body>
          <div className={isInternal ? "authore_name internal-article-author" : "authore_name"}>
            {article.id ? (
              <h5
                onClick={() =>
                  isInternal
                    ? getAuthorProfile(article.userId || article.postedById || article.createdById)
                    : getCompany(article.userId ? article.userId : article.createdById)
                }
              >
                <span className="internal-article-name">{article.userFullName || article.postedByName}</span>
                {isInternal && articleBranch && (
                  <span className="internal-article-branch" data-tooltip={articleBranch}>- {articleBranch}</span>
                )}
              </h5>
            ) : (
              <Skeleton variant="text" />
            )}
          </div>
          {!isInternal ? (
            <div className="w-100">
              {article.postedByName ? (
                <h6>
                  {/* {strings.by}{" "} */}
                  <span className="text-73 company-feed__author-name">
                    {article.postedByName ? (
                      article.postedByName
                    ) : (
                      <Skeleton variant="text" />
                    )}
                  </span>{" "}
                  -
                  <span>
                    {" "}
                    {article.id ? articleBranch : <Skeleton variant="text" />}
                  </span>
                </h6>
              ) : (
                <Skeleton variant="text" />
              )}

              <div className="w-100">
                {article.product ? (
                  <h6 className="product_user">
                    Product: <span>{article.product}</span>
                  </h6>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            null
          )}
        </Media.Body>
      </Media>
      {isInternal && article.deptLocation && Array.isArray(article.deptLocation) && article.deptLocation.filter(d => d && d.departmentLocation).length > 0 && (
        <div className="article-dept-location-tabs">
          {article.deptLocation.filter(d => d && d.departmentLocation).map((dept, i) => (
            <span key={dept.deptLocation || i} className="article-dept-location-tab">
              {dept.departmentLocation}
            </span>
          ))}
        </div>
      )}
      {article.id ? (
        <p className="m-0 mt-2 mb-2 company-feed__title">
          <span className="article-title-markdown">
            <HighlightText text={toPlainArticleTitle(article.title || '')} query={searchQuery} />
          </span>
        </p>
      ) : (
        <Skeleton variant="text" />
      )}
      {article?.description ? (
        <div
          ref={descriptionRef}
          className={shouldLimitMedia ? "company-feed-image-scope" : undefined}
        >
          <div className="small company-feed__desc">
            <ReadMores isInternal={isInternal} searchQuery={searchQuery}>{article?.description}</ReadMores>
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* {_Link && _Link.length > 0 && */}
      <div className={shouldLimitMedia ? "company-feed-image-scope" : undefined}>
        <PlayerFeed
          Links={_Link}
          article={article}
          viewArticleDetail={viewArticleDetail}
          isInternal={isInternal}
          onPress={(data, index) => {
            // Open FullScreenImageViewer via Redux (same as chat)
            dispatch({ type: SET_VIEWER_IINITAL_INDEX, index: index });
            dispatch({ type: SET_VIEWER_IMAGES, ViewerImages: data });
            dispatch({ type: SET_VIEWER_IS_INTERNAL, isInternal: isInternal });
          }}
        />
      </div>
      {/* } */}
      <div className="date-follow">
        <p>{(article.publishedAt)? (
          new Date(Number(article.publishedAt) * 1000).toLocaleDateString(isGerm ? 'de-DE' : 'en-GB', {
            day: 'numeric',
            month: 'long'
          }) + ', ' + new Date(Number(article.publishedAt) * 1000).toLocaleTimeString(isGerm ? 'de-DE' : 'en-US', {
            hour: '2-digit',
            minute: '2-digit'
          })
        ) : (
          new Date(article.createdAt).toLocaleDateString(isGerm ? 'de-DE' : 'en-GB', {
            day: 'numeric',
            month: 'long'
          }) + ', ' + new Date(article.createdAt).toLocaleTimeString(isGerm ? 'de-DE' : 'en-US', {
            hour: '2-digit',
            minute: '2-digit'
          })
        )}</p>
        {article.likeCount > 0 && article.likes && (
          <LikesDropdown 
            articleId={article.id} 
            likes={article.likes} 
            likeCount={article.likeCount}
            isInternal={isInternal}
            
          >
            <div 
              className="follow-img company-feed__likes"
              data-tip
              data-for={`likes-tooltip-${article.id}`}
              onMouseEnter={() => setShowLikesTooltip(true)}
              onMouseLeave={() => setShowLikesTooltip(false)}
            >
              <div className="likes-avatar-container">
                {(() => {
                  const getLikeAvatarUrl = (likeUser) => {
                    const avatar = likeUser?.avatar || likeUser?.userAvatar || likeUser?.userImage || likeUser?.userProfileImage || likeUser?.postedByImage || likeUser?.profileImage;
                    if (!avatar) return null;
                    if (typeof avatar === 'string' && (avatar.startsWith('http://') || avatar.startsWith('https://'))) return avatar;
                    return BASE_URL + avatar;
                  };
                  const likesArray = Array.isArray(article.likes) ? article.likes : [article.likes].filter(Boolean);
                  return likesArray.slice(0, Math.min(1, likesArray.length)).map((like, i) => (
                    <img
                      key={like?.id || `like-${i}`}
                      src={getLikeAvatarUrl(like) || process.env.PUBLIC_URL + "/assets/img/profile.png"}
                      alt={like?.userFullName || like?.fullName || like?.name || "User"}
                      className={`like-avatar-enter company-feed__like-avatar${i > 0 ? " company-feed__like-avatar--stacked" : ""}`}
                      style={{ '--company-feed-like-z': 2 - i }}
                      onError={e => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/assets/img/profile.png"; }}
                    />
                  ));
                })()}
                
              </div>
              <span className="like-count-transition company-feed__like-count">
                {(() => {
                  const likesArray = Array.isArray(article.likes) ? article.likes : [article.likes].filter(Boolean);
                  const firstLike = likesArray[0];
                  const userName = firstLike?.userFullName || firstLike?.fullName || firstLike?.name ||
                    (firstLike?.firstName && firstLike?.lastName ? `${String(firstLike.firstName).trim()} ${String(firstLike.lastName).trim()}` : null);
                  if (userName && article.likeCount > 0) {
                    if (article.likeCount === 1) {
                      return userName;
                    } else {
                                      return `${userName} ${strings.and} ${article.likeCount - 1} ${strings.others}`;
                    }
                  }
                  
                  return `${article.likeCount}`;
                })()}
              </span>
            </div>
          </LikesDropdown>
        )}
        {article.isEmojiUsed && (
          <SmilyIcon
            width={20}
            className={`${isInternal ? "smily-icon-internal" : "smily-icon"} active float-right`}
          />
        )}
      </div>
      <div
        className={
          !isInternal
            ? user?.id === article.postedById
              ? "date-follow no-border like_folo no-hover-effect noHover"
              : "date-follow no-border noHover"
            : user?.id === article.postedById
              ? "date-follow no-border-internal like_folo no-hover-effect noHover"
              : "date-follow no-border-internal noHover"
        }
      >
        <a
          onClick={(e) => {
            if (user?.id !== article.postedById) {
              likeArticle(article);
            }
          }}
          onMouseEnter={() => user?.id !== article.postedById && setLikeHover(true)}
          onMouseLeave={() => setLikeHover(false)}
          className={`date-follow-link ${user?.id === article.postedById ? 'date-follow-link-deactivated' : 'pointer'} ${article.likeStatus
            ? isInternal
              ? "social-icon-active_internal"
              : "social-icon-active"
            : ""
            } ${likeStatus && user?.id !== article.postedById
              ? "bouncing-animation"
              : ""
            } company-feed__like-link${(likeHover && user?.id !== article.postedById) ? ` company-feed__like-link--hover${isInternal ? ' company-feed__like-link--internal' : ''}` : ''}`}
        >
          <MaterialIcon
            icon="thumb_up"
            size={24}
            weight={300}
            fill={article.likeStatus ? 1 : 0}
            color={user?.id === article.postedById
              ? '#e0e0e0'
              : likeHover
                ? (isInternal ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)')
                : article.likeStatus
                  ? (isInternal ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)')
                  : '#737373'}
            className="mr-1 company-feed__like-icon"
          />
          <span
            className={`date-follow-label company-feed__like-label${user?.id === article.postedById
              ? ''
              : (likeHover || article.likeStatus)
                ? ` company-feed__like-label--active${isInternal ? ' company-feed__like-label--internal' : ''}`
                : ' company-feed__like-label--idle'}`}
          >
            {strings.like}
          </span>
        </a>
      </div>
    </div>
  );
}

